import kronosSamSchema from "../schemas/kronos-sam.graphql?raw";
import kronosSchema from "../schemas/kronos.graphql?raw";

export const endpoints: Record<string, string> = {
  "https://api.sam.nimaru.jp/graphql": "kronosSam",
  "https://api.trial.sam.nimaru.jp/graphql": "kronosSam",
  "https://api.development.sam.kronos-staging.net/graphql": "kronosSam",
  "http://localhost:48889/graphql": "kronosSam",
  "https://api.nimaru.jp/graphql": "kronos",
  "https://api.trial.nimaru.jp/graphql": "kronos",
  "https://api.development.kronos-staging.net/graphql": "kronos",
  "http://localhost:48888/graphql": "kronos",
};

const schemas: Record<"kronosSam" | "kronos", string> = {
  kronosSam: kronosSamSchema,
  kronos: kronosSchema,
};

export async function loadSchema(endpoint: string): Promise<string> {
  const key = endpoints[endpoint] as "kronosSam" | "kronos";
  return schemas[key];
}
